<h2>Stock aanpassen</h2>

<ng-container *ngIf="isStockItemEditable">
  <div class="flex-row field-input">
    <label>Soort locatie</label>
    <mat-form-field appearance="outline">
      <mat-select
        matInput
        placeholder="Maak een keuze"
        [(ngModel)]="editRequest.locationType"
        [compareWith]="compareLocationType"
        required
      >
        <mat-option *ngFor="let option of locationTypeChoices" [value]="option">
          {{ option.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <ng-container *ngIf="editRequest.locationType === PHYSICAL_LOCATION">
    <div class="flex-row field-input">
      <label>Rek</label>
      <mat-form-field appearance="outline">
        <input matInput [(ngModel)]="editRequest.rack" required />
      </mat-form-field>
    </div>
    <div class="flex-row field-input">
      <label>Schap</label>
      <mat-form-field appearance="outline">
        <input matInput [(ngModel)]="editRequest.shelf" required />
      </mat-form-field>
    </div>
    <div class="flex-row field-input">
      <label>Vaknummer</label>
      <mat-form-field appearance="outline">
        <input
          type="number"
          matInput
          [(ngModel)]="editRequest.compartment"
          required
        />
      </mat-form-field>
    </div>
  </ng-container>

  <div class="flex-row field-input">
    <label>Frame</label>
    <mat-form-field appearance="outline">
      <mat-select
        matInput
        placeholder="Niet op frame"
        [(ngModel)]="editRequest.frame"
        [compareWith]="compareFrame"
      >
        <mat-option *ngFor="let option of frameChoices" [value]="option">
          {{ option ? option.label : 'Niet op frame' }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</ng-container>

<div class="flex-row field-input">
  <label>Toename</label>
  <mat-form-field appearance="outline">
    <input
      type="number"
      matInput
      [(ngModel)]="editRequest.amountIncrease"
      required
    />
  </mat-form-field>
</div>

<div class="confirm-container border-top">
  <button class="btn button" type="button" (click)="save()">
    <span>Opslaan</span>
  </button>
</div>
